import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { INVITE_STORAGE_KEY } from "../lib/me.tsx";

/** /i/<code>: remembers the invite through login (R-INV-3), redeemed from Settings → Become a seller (T1.6). */
export function InviteLanding() {
  const { code } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    try {
      if (code) localStorage.setItem(INVITE_STORAGE_KEY, code.toUpperCase());
    } catch {
      /* ignore */
    }
    navigate("/login?next=/me/settings", { replace: true });
  }, [code, navigate]);
  return null;
}
